import { getAdditionalFeesOrderItems } from './getAdditionalFeesOrderItems';
import { ExpressOrderItem, ExpressOrderItemType } from '../types';
import { checkIfItemHasDiscount } from './discounts.utils';
import { CartModel } from '../models/Cart.model';
import { SummaryModel } from '../models/Summary.model';
import { LineItemModel } from '../models/LineItem.model';
import { LineItemDiscountModel } from '../models/LineItemDiscount.model';

const MAX_ITEM_NAME_LENGTH = 1200;

function lineItemToOrderItem(
  lineItem: LineItemModel,
  /* istanbul ignore next */
  discountsToAlignWith: LineItemDiscountModel[] = [],
): ExpressOrderItem {
  const amount = lineItem.unitPrice?.amount ?? /* istanbul ignore next */ '0';
  const priceBeforeDiscounts = lineItem.salePrice?.amount ?? '0';
  const price = checkIfItemHasDiscount(lineItem, discountsToAlignWith)
    ? priceBeforeDiscounts
    : amount;
  return {
    id: lineItem.id,
    name: getItemName(lineItem),
    price,
    quantity: lineItem.confirmedQuantity ?? /* istanbul ignore next */ 0,
    type: ExpressOrderItemType.Product,
  };
}

export function getOrderItemsFromCheckout(
  cart: CartModel,
  summary: SummaryModel,
  /* istanbul ignore next */
  discountsToAlignWith: LineItemDiscountModel[] = [],
) {
  const orderItems =
    cart.lineItems?.map((lineItem) =>
      lineItemToOrderItem(lineItem, discountsToAlignWith),
    ) ?? /* istanbul ignore next */ [];

  const additionalFeesAsOrderItems = getAdditionalFeesOrderItems(
    summary.additionalFees ?? /* istanbul ignore next */ [],
  );
  return [...orderItems, ...additionalFeesAsOrderItems];
}

function getItemName(lineItem: LineItemModel) {
  const { name, description } = lineItem;

  const displayName = description ? `${name}${description}` : name;

  if (displayName.length > MAX_ITEM_NAME_LENGTH) {
    return displayName.substring(0, MAX_ITEM_NAME_LENGTH);
  }

  return displayName;
}
